// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBKXB2dEqCUy2kXRu5q8ErO37LrSLP9TSs",
  authDomain: "f-ai-c094b.firebaseapp.com",
  projectId: "f-ai-c094b",
  storageBucket: "f-ai-c094b.appspot.com",
  messagingSenderId: "245190212416",
  appId: "1:245190212416:web:2ad2b421ad82a2c6a0d8a5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;